function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bBoxClass{stroke-linecap:round;stroke-linejoin:round;stroke-width:0.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "bBoxClass",
  fill: "currentColor",
  stroke: "currentColor",
  d: "M401.14,672.45H401c-.1,0-.2-.1-.2-.4v-1.5h-4.7v-2.5a.68.68,0,0,1,.7-.7h4v-1.6c0-.3.1-.4.2-.4h.1c.1,0,.2.1.3.2l3.4,3.4-3.4,3.4A.37.37,0,0,1,401.14,672.45Zm-.7-2.3a.68.68,0,0,1,.7.7v1.3l3.3-3.3-3.3-3.3v2.1h-4.3a.35.35,0,0,0-.4.4v2.2l4-.1Z",
  transform: "translate(-390.69 -662.7)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "bBoxClass",
  fill: "currentColor",
  stroke: "currentColor",
  d: "M394.64,670.35c-.2,0-.3-.1-.5-.2l-2.9-2.9a.75.75,0,0,1,0-1.2l2.9-2.9a.76.76,0,0,1,.5-.2h.2c.1,0,.3.2.3.6v1.2c0,.1,0,.1.1.1l.1.1H399a.86.86,0,0,1,.6.3,2.19,2.19,0,0,1,.3.5h-.4c0-.1-.1-.2-.2-.3a.52.52,0,0,0-.4-.2h-3.7c-.1,0-.2-.1-.3-.1a.37.37,0,0,1-.1-.3v-1.4c0-.2,0-.3-.1-.3h-.1c-.1,0-.2,0-.2.1l-2.9,2.9a.5.5,0,0,0,0,.8l2.9,2.9a.31.31,0,0,0,.2.1h.1c.1,0,.1-.1.1-.3v-1.2h.3v1.2a.68.68,0,0,1-.3.6C394.84,670.35,394.74,670.35,394.64,670.35Z",
  transform: "translate(-390.69 -662.7)"
});

function SvgIconBBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.4 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBBox);
export default __webpack_public_path__ + "static/media/icon-b-box.592a6181.svg";
export { ForwardRef as ReactComponent };